import { BaseWidgetFormFields } from 'components/consumer-page-widgets/BaseWidgetFormFields';
import { Button, Typography } from 'ui';
import {
  CardLinkWidgetFields,
  CardLinkWidgetFormFields,
} from 'components/consumer-page-widgets/card-link-widget/CardLinkWidgetFormFields';
import { Form, Formik } from 'formik';
import { consumer } from '@tock/coretypes';
import {
  getBaseFormFieldsInitialValues,
  useUpdateNamedConfigurations,
} from 'components/consumer-page-widgets/widgetFormUtils';
import {
  widgetFormButtonContainer,
  widgetFormRoot,
} from 'components/consumer-page-widgets/widgetFormCssDefs';
import React, { FunctionComponent } from 'react';

interface UpdateCardLinkWidgetFormProps {
  selectedWidgetToEdit?: consumer.NamedConfiguration;
  onCompleteOrCancel(): void;
}

export const UpdateCardLinkWidgetForm: FunctionComponent<
  React.PropsWithChildren<UpdateCardLinkWidgetFormProps>
> = ({ selectedWidgetToEdit, onCompleteOrCancel }) => {
  const updateNamedConfig = useUpdateNamedConfigurations();

  if (!selectedWidgetToEdit?.cardLinkWidgetConfig) {
    return null;
  }

  const { imageUrl, imageAlt, tagline, linkText, linkHref, variant } =
    selectedWidgetToEdit.cardLinkWidgetConfig;

  const handleSubmit = (values: CardLinkWidgetFields) => {
    return updateNamedConfig({
      ...selectedWidgetToEdit,
      cardLinkWidgetConfig: values,
    }).then(onCompleteOrCancel);
  };

  return (
    <>
      <Typography variant="heading1Bold">Editing widget: {selectedWidgetToEdit.name}</Typography>
      <Formik<CardLinkWidgetFields>
        enableReinitialize
        initialValues={{
          ...getBaseFormFieldsInitialValues({ widgetToEdit: selectedWidgetToEdit }),
          imageUrl: imageUrl ?? '',
          imageAlt: imageAlt ?? '',
          tagline: tagline ?? '',
          linkText: linkText ?? '',
          linkHref: linkHref ?? '',
          variant: variant ?? 'DEFAULT',
        }}
        onSubmit={handleSubmit}
      >
        <Form css={widgetFormRoot}>
          <BaseWidgetFormFields />
          <CardLinkWidgetFormFields />
          <div css={widgetFormButtonContainer}>
            <Button type="submit">Submit</Button>
            <Button onClick={onCompleteOrCancel} type="button" variant="outlined">
              Cancel
            </Button>
          </div>
        </Form>
      </Formik>
    </>
  );
};
